var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFurniture = function SvgIconFurniture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 25.246h-3V7.006h24v18.24h-3m-18 0h18m-18 0v-11.36m18 11.36v-11.36m0 0v-3.88h-18v3.88m18 0h-18",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
};
export { SvgIconFurniture as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAyNS4yNDU5SDQuNVY3LjAwNTg2SDI4LjVWMjUuMjQ1OUgyNS41TTcuNSAyNS4yNDU5SDI1LjVNNy41IDI1LjI0NTlWMTMuODg1OU0yNS41IDI1LjI0NTlWMTMuODg1OU0yNS41IDEzLjg4NTlWMTAuMDA1OUg3LjVWMTMuODg1OU0yNS41IDEzLjg4NTlINy41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";